module.exports = __webpack_public_path__ + "world-expo-large.jpg?24cf0083b666a779b0f43432c8d6bf3b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/world-expo-large.jpg
// module id = 273
// module chunks = 0